import React, { useEffect, useState } from 'react';
import { TOKEN_DATA_KEY } from 'constants/login';
import { useSelector } from 'react-redux';

function useIsAuthenticated() {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const { isLoginModalOpen } = useSelector((store) => store.defaultReducer);

  useEffect(() => {
    getIsUserLoggedIn();
  }, [isLoginModalOpen]);

  function getIsUserLoggedIn() {
    if (localStorage.getItem(TOKEN_DATA_KEY)) {
      setIsUserLoggedIn(true);
      return;
    }

    setIsUserLoggedIn(false);
    return;
  }

  return { isUserLoggedIn };
}

export default useIsAuthenticated;
